import React, { useState, useEffect, useRef } from 'react'
import { useEthers, MoonbaseAlpha, Moonbeam } from '@usedapp/core';
import { useEtherBalance } from '@usedapp/core';
import playNow from '../assets/play_now_btn.png'
import signout from '../assets/signout.png'
import metamask from '../assets/metamask_logo.png'
import moonbeam from '../assets/moonbeam.png'
import moonbase from '../assets/moonbase.png'
import { formatEther } from '@ethersproject/units'
import novip from '../assets/novip.png'
import vip from '../assets/vip.png'
import goldvip from '../assets/goldvip.png'
import diamondvip from '../assets/diamondvip.png'
import { ZOOMBIES_WORLD } from '../constants';
import './Right.css'
import lottie from 'lottie-web';
import gold from '../assets/Gold.json'

const RightTopContainer = (props) => {

    const balance = useEtherBalance(props.account); 
    const url = ZOOMBIES_WORLD; 
    
    const goldAnim = useRef(null);
    const goldContainer = useRef(null);

    const { switchNetwork } = useEthers();

    const switchHandler = async () => {
        switchNetwork(Moonbeam.chainId);
    }

    const signOutButtonHandler = () => {
        props.deactivate();
        props.setVipStatus(0);
    }

    useEffect( () => {
        if(goldContainer.current) {
            goldAnim.current = lottie.loadAnimation({
                container: goldContainer.current,
                renderer: "svg",
                loop: true,
                autoplay: true,
                animationData: JSON.parse(JSON.stringify(gold))
            })

            return () => {
                goldAnim.current?.destroy();
            }
        }
    }, [])

    return (
        <>
            <div style={{marginLeft: '5%'}}>
                <div className="acc-display">
                    {!props.correctChain ? <div className="switch" onClick={switchHandler}>Switch to Moonbeam</div> : <></>}
                    {props.account && props.correctChain? <img className="mmlogoacc" src={metamask} alt="Metamask Logo"/> : <></>}
                    {props.account && props.correctChain && props.vipStatus != 2 ? <img className="mmlogoacc" src={props.vipStatus === 0 ? novip : props.vipStatus === 1 ? vip : diamondvip } alt="Current VIP shield"/> : <></>}
                    {<span ref={goldContainer} className={`gold-lottie ${props.vipStatus != 2 ? 'hidden' : ''}`}></span>}
                    <div>{
                        props.account && props.correctChain ? `${props.account.substring(0, 6)}...${props.account.substring(props.account.length - 5, props.account.length)}`
                        : ''
                    }</div>
                </div>
                <div className="balance-display">
                    {props.account && props.correctChain ? <img className="mmlogoacc" src={props.chainId == '1287' ? moonbase : moonbeam} alt="Moonbeam Logo"/> : <></>}
                    <div>{
                        balance && props.correctChain ? formatEther(balance).toString()
                        : ''
                    }</div>
                </div>
            </div>
            <div className="centering-button">
                <div className="sign"> 
                    { props.account && !props.pending ? 
                    <>
                        <img src={signout} className="signout" alt="Sign Out" onClick={signOutButtonHandler}/> 
                        <div className="button-text signtxt" onClick={signOutButtonHandler}>SIGN OUT</div>
                    </>
                    : <></>}
                </div>
            </div>
            <div className='centering-button'>
                <div className="play">
                    { !props.pending ? 
                    <>
                        <img src={playNow} className="play-now" alt="Play Now" onClick={() => { window.open(url, '_blank') }}/>
                        <div className="button-text" onClick={() => { window.open(url, '_blank') }}>PLAY NOW</div>
                    </> 
                    : <></>}
                </div>
            </div>
        </>
    )
}

export default RightTopContainer
